import { Column, Columns, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { WhatWeOfferTypes } from './WhatWeOfferTypes';
import { ThemeContext } from './hooks/themeContext';
import { getBackgroundColor, getTextColor } from './helpers/getColorTheme';
import {
  isDefaultEvenVariant,
  isLongAmenitiesList,
} from './helpers/generalHelpers';
import { AmenitiesList } from './components/AmenitiesList';
import { RenderDefaultVariantAmenitiesList } from './components/DefaultVariantAmenitiesList';
import { RenderLongAmenitiesList } from './components/LongAmenitiesList';

export const WhatWeOffer = ({
  variant,
  theme,
  title,
  descriptionDetails,
  otherBenefitsIconDetails,
}: WhatWeOfferTypes.IWhatWeOffer) => {
  const DefaultVariant = () => {
    return (
      <>
        <Column
          marginless
          className={`has-text-${getTextColor(
            theme
          )} defaultVariantTitleContainer`}
        >
          <div className="is-flex">
            <span className="whatWeOfferHeadingBorder"></span>
            <h3>{title}</h3>
          </div>
          <p className="pt-5 mt-2 subtitle2">
            {descriptionDetails.description}
          </p>
        </Column>
        <RenderDefaultVariantAmenitiesList
          otherBenefitsIconDetails={otherBenefitsIconDetails}
        />
      </>
    );
  };

  const LongAmenitiesList = () => {
    return (
      <div className="longAmenitiesListSectionContainer">
        <Column
          marginless
          paddingless
          className={`has-text-${getTextColor(theme)} titleContainer`}
        >
          <div className="is-flex">
            <span className="whatWeOfferHeadingBorder"></span>
            <h3>{title}</h3>
          </div>
          <p className="pt-5 mt-2 subtitle2">
            {descriptionDetails.description}
          </p>
        </Column>
        <RenderLongAmenitiesList
          otherBenefitsIconDetails={otherBenefitsIconDetails}
        />
      </div>
    );
  };

  const VerticalFeaturesList = () => {
    return (
      <Columns marginless className="VerticalFeaturesList">
        <Column className={`has-text-${getTextColor(theme)} headingSection`}>
          <div className="is-flex">
            <span className="whatWeOfferHeadingBorder"></span>
            <h3>{title}</h3>
          </div>
          <p className="pt-5 mt-2 subtitle2">
            {descriptionDetails.description}
          </p>
        </Column>
        <AmenitiesList otherBenefitsIconDetails={otherBenefitsIconDetails} />
      </Columns>
    );
  };

  const HorizontalFeaturesList = () => {
    return (
      <div className="HorizontalFeaturesList">
        <Column
          paddingless
          className={`has-text-${getTextColor(theme)} is-full headingSection `}
        >
          <div className="is-flex">
            <span className="whatWeOfferHeadingBorder"></span>
            <h3>{title}</h3>
          </div>
          <p className="pt-5 mt-2 subtitle2">
            {descriptionDetails.description}
          </p>
        </Column>
        <AmenitiesList otherBenefitsIconDetails={otherBenefitsIconDetails} />
      </div>
    );
  };

  const renderSwitch = (variant: WhatWeOfferTypes.TVariantModes) => {
    switch (variant) {
      case 'FeaturesListHorizontal':
        return <HorizontalFeaturesList />;
      default:
        return <VerticalFeaturesList />;
    }
  };

  const RenderComponent = () => {
    if (isDefaultEvenVariant(otherBenefitsIconDetails)) {
      return <DefaultVariant />;
    } else if (isLongAmenitiesList(otherBenefitsIconDetails)) {
      return <LongAmenitiesList />;
    } else {
      return renderSwitch(variant);
    }
  };

  return (
    <ThemeContext.Provider value={theme}>
      <div className={`has-background-${getBackgroundColor(theme)} is-flex`}>
        <Container className="whatWeOfferContainer">
          {variant && <RenderComponent />}
        </Container>
      </div>
    </ThemeContext.Provider>
  );
};
